import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import Select from '../../../core/form/Select';
import { startCase } from 'lodash';
import AudioPreview from '../../../core/layout/AudioPreview';
import Button from '../../../core/form/Button';
import Dialog from '../../../core/layout/Dialog';
import Table from '../../../core/form/Table';

const CharacterVoiceSearchDialog = (props) => {
  return (
    <Dialog title="Voices" isOpen={!!props.isOpen} onCancel={props.onClose} width="75%" actions={[]}>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          props.onFilter();
        }}
      >
        <Row>
          <Column size={2}>
            <Select
              options={['library', 'cloned'].map((value) => ({
                value,
                label: startCase(value),
              }))}
              label="Type"
              value={get(props.values, 'type', '')}
              onChange={(value) => {
                props.onChange('type', value);
              }}
            />
          </Column>
          <Column size={4}>
            <TextInput
              label="Search"
              value={get(props.values, 'criteria', '')}
              onChange={(value) => props.onChange('criteria', value)}
            />
          </Column>
          <Column size={2}>
            <Select
              options={['young', 'middle_aged', 'old'].map((value) => ({
                value,
                label: startCase(value),
              }))}
              label="Age"
              value={get(props.values, 'age', '')}
              onChange={(value) => {
                props.onChange('age', value);
              }}
            />
          </Column>
          <Column size={2}>
            <Select
              options={['male', 'female', 'neutral'].map((value) => ({
                value,
                label: startCase(value),
              }))}
              label="Gender"
              value={get(props.values, 'gender', '')}
              onChange={(value) => {
                props.onChange('gender', value);
              }}
            />
          </Column>
          <Column size={2}>
            <div style={{ marginTop: 44 }}>
              <Button icon="search" label="Search" buttonType="submit" />
            </div>
          </Column>
        </Row>
      </form>

      <Table
        rows={props.voices}
        selectable
        onSelect={(row) => {
          props.onSelect(row);
          props.onClose();
        }}
        fetching={props.fetching}
        columns={[
          {
            label: 'Name',
            path: 'name',
          },
          {
            label: 'Gender',
            path: 'gender',
          },
          {
            label: 'Age',
            path: 'age',
          },
          {
            label: 'Description',
            path: 'description',
          },
          {
            label: 'Preview',
            path: 'action',
            width: '105px',
            render: (cell, row) => {
              return row.previewUrl ? <AudioPreview src={row.previewUrl} external /> : null;
            },
          },
        ]}
      />
    </Dialog>
  );
};

CharacterVoiceSearchDialog.propTypes = {
  isOpen: PropTypes.func,
  onClose: PropTypes.func,
  onFilter: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  voices: PropTypes.array,
};

export default CharacterVoiceSearchDialog;
